import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useState } from "react";

import PropertySingle from "../../propertyNew/PropertySingle";
import PropertyComment from "../../property/PropertyComment";
import PropertyNotes from "../../../components/notes/PropertyNotes";

const FollowPropertyCustomerDetail = () => {
  const { Id } = useParams();
  const loggedInUser = useSelector((state) => state.auth.user);
  const userType = loggedInUser?.userDetails?.userType;
  const [ownerId, setOwnerId] = useState(null);

  return (
    <div className=" mb-4 pb-4"> 
      <PropertySingle 
        backBtn={'/dashboard/PropertyDashboard'} 
        ownerId={setOwnerId} 
      />
      <PropertyComment 
        Id={Id} 
        ownerId={ownerId}
        commentType="propertyComments"
        allComments={`/property/requestPropertyComments`}
        addComment={`/property/addRequestPropertyComment`}
        editComment={`/property/editRequestPropertyComment`}
        deleteComment={`/property/deleteRequestPropertyComment/`}
      /> 
      {userType === "PARTNER" && 
        <PropertyNotes />
      }
    </div>
  );
}

export default FollowPropertyCustomerDetail;